import type { ChartAdditionalParams, ChartSeries } from 'shared/domain/analytics/chartModel';
import { FilterValues, InspectionChart, IssueChart } from 'shared/types/analytics';
import {
  makeDefaultAddBatch,
  makeDefaultGetOne,
} from './defaultDaoFactories';
import db from './index';

interface ChartData {
  series: ChartSeries;
  filters: FilterValues;
  projectId: string;
  name: IssueChart | InspectionChart;
  locale: string;
  additionalParams: ChartAdditionalParams | undefined;
  updatedAt: number;
}

export type ChartDataEntity = {
  _id: string;
} & ChartData;

export const getOne = makeDefaultGetOne<
  IssueChart | InspectionChart,
  ChartDataEntity
>(db, db.analytics, 'name');

export const addBatch = makeDefaultAddBatch<ChartDataEntity>(
  db,
  db.analytics
);
